<ul>
    <li *ngFor="let folder of foldersAvailable">
        {{assignPathToFolder(folder)}}
        <div class="bmc-ecm-container-folders-list__item">
            <bzg-radio-button class="bmc-ecm-container-folders-list__radio" (change)="selectFolder(folder)"
                [checked]="selectedFolder.environment.params.externalId === folder.Id"
                [style.margin-right]="marginRightRadio + 'px'"></bzg-radio-button>
            <bzg-icon [nameIcon]="'icon-folder'"></bzg-icon>
            <label (click)="getFolderChild(folder)">{{folder.Value}}</label>
        </div>

        <connect-ecm-folders-list *ngIf="foldersChildren && selectedFolderId === folder.Id"
            [selectedFolder]="selectedFolder" [parentName]="folder.path"
            (onShowLoadingNodes)="onShowLoadingNodesEvent($event)" [selectedRepository]="selectedRepository"
            [foldersAvailable]="foldersChildren" [isChild]="true" [marginRightRadio]="marginRightRadio + 20">
        </connect-ecm-folders-list>
    </li>
</ul>
